export const log = {
  account: "Account",
  add: "Add",
  addDetail: 'Add {0} {1}""',
  bind: "Bind",
  changeItemAdd: "Add",
  changeItemDelete: "Delete",
  delete: "Delete",
  deleteDetail: 'Delete {0} "{1}"',
  detail: "Details",
  device: "Setting",
  driver: "Driver",
  edit: "Edit",
  editDetail: 'Edit {0} "{1}"',
  fleet: "Fleet",
  fleetColor: "Fleet Color",
  geofence: "Geofence",
  inspectionTemplate: "Inspection Template",
  logDate: "Time",
  logDetail: "Log Details",
  login: "Sign In",
  logNumber: "No.",
  logout: "Sign Out",
  maintenance: "Maintenance",
  maintenanceTemplate: "Maintenance  Template",
  mobile: "Mobile Phone Number",
  model: "Model",
  name: "Name",
  operationObject: "Object",
  objectName: "Object Name",
  operationType: "Type",
  operationUser: "Account",
  passwordChange: "Change Password",
  remind: "Reminder",
  remindSetting: "Reminder",
  repair: "Repair",
  role: "Role",
  unbind: "Unregister",
  vehicle: "Vehicle",
  visitIP: "Access IP",
  itemName: "Item Name",
  groupName: "Group Name",
  inspectionItem: "Inspection Item",
  inspectionGroup: "Inspection Group",
  inspection: "Inspection Report",
};
